import { Area } from "@ant-design/plots";
import { Row } from "antd";
import { Loader } from "./Loader";
import { useSingleLineChartConfig } from "../hooks/useSingleLineChartConfig";
import { memo } from "react";

type ChartProps = {
  data: any;
  isLoading: boolean;
  isAmout?: boolean;
};

const AreaChart = ({ data, isLoading, isAmout }: ChartProps) => {
  const { config } = useSingleLineChartConfig(data, 332, 348, isAmout);

  return (
    <Row className="mt-4 w-100">
      {!isLoading ? (
        <Area {...config} />
      ) : (
        <Row className="w-100 mt-10 pt-10 justify-center">
          <Loader />
        </Row>
      )}
    </Row>
  );
};

export default memo(AreaChart);
